var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowForwardIosarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 9 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.34984 13.6668L0.166504 12.4835L5.64984 7.00016L0.166504 1.51683L1.34984 0.333496L8.0165 7.00016L1.34984 13.6668Z",
    fill: "#28519E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowForwardIosarrow);
export default __webpack_public_path__ + "static/media/arrow_forward_iosarrow.d85a85a97a5531acb3357020dd178384.svg";
export { ForwardRef as ReactComponent };